export default __webpack_public_path__ + "static/media/contacto_4.482becd9.jpeg";